<template>
  <div>
    <h1>Secure Page</h1>
    <h5>Data from GET /secure-data:</h5>
    <div class="results">
      <pre>{{ data }}</pre>
    </div>
    <div>
      <router-link to="/">Go back</router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      data: null,
    };
  },
  async mounted() {
    const accessToken = await this.$auth.getAccessToken();
    const client = axios.create({
      baseURL: 'https://7yt2za0ijd.execute-api.us-east-1.amazonaws.com/dev/',
      // baseURL: 'http://localhost:8081',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    // const { data } = await client.get('/secure-data');
    const { data } = await client.get('/crosswalks');
    this.data = data;
  },
};
</script>

<style>
  .results {
    width: 300px;
    margin: 0 auto;
    text-align: left;
    background: #eee;
    padding: 10px;
  }
</style>
